export default "__VITE_ASSET__D267Zxms__"